import { connect } from 'react-redux';
import React from 'react';
import FormElement from 'components/FormElement';
import { getFullName } from 'helpers/Users';

const DeviceInfoSubmitter = ({ request }) => {
  if (request.id > 0) {
    return (
      <FormElement
        id="submitter"
        label="Submitter"
        value={getFullName(request.submitter)}
      />
    );
  }

  return null;
};

function mapStateToProps({ request }) {
  return { request };
}

export default connect(mapStateToProps)(DeviceInfoSubmitter);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/Steps/Vendor/DeviceInfoSubmitter.js